const eventBaseType = 'MY CLOSET'
/* eslint-disable @typescript-eslint/naming-convention */
const event_category = 'my closet'
const category_id = 'FAVOURITES'
const page_id = 'MY CLOSET'
const category_path = 'FAVOURITES'

const category_id_detail = 'FAVOURITES_MY CLOSET'
const category_path_detail = 'favourites/my_closet'

export const MYCLOSET_TRACKING_EVENTS = {
  myclosetLoginView: {
    event_type: `${eventBaseType}_LOGIN_VIEW`,
    event_id: 'Log in requested',
    event_label: 'login view',
    event_category,
    category_id,
    category_path,
    page_id: 'MY CLOSET LOGIN',
  },
  clickOnLogin: {
    event_type: `${eventBaseType}_LOGIN_CLICK`,
    event_id: 'login click',
    event_category,
    event_label: 'login click',
    category_id,
    category_path,
    customer_bpid: '',
    page_id: 'MY CLOSET LOGIN',
  },
  BrowseNowView: {
    event_type: `${eventBaseType}_BROWSENOW_VIEW`,
    event_id: 'browse now requested',
    event_label: 'browse now view',
    event_category,
    category_id,
    category_path,
    page_id: 'MY CLOSET BROWSE NOW',
  },
  clickStartBrowsing: {
    event_type: `${eventBaseType}_BROWSENOW_CLICK`,
    event_id: 'browse now click',
    event_category,
    event_label: 'browse now click',
    category_id,
    category_path,
    page_id: 'MY CLOSET BROWSE NOW',
  },
  clickOnPDP: {
    event_type: `${eventBaseType}_PDP_CLICK`,
    event_id: 'pdp Click',
    event_category,
    category_id,
    category_path,
    page_id,
  },
  clickCategoryFilter: {
    event_type: `${eventBaseType}_CATEGORY_FILTER_CLICK`,
    event_id: 'filter click',
    event_category,
    category_id,
    category_path,
    page_id,
    event_label: 'categories',
  },
  clickViewallBtn: {
    event_type: `${eventBaseType}_VIEW_ALL_CLICK`,
    event_id: 'view all',
    event_category,
    category_id,
    category_path,
    page_id,
  },
  categorySubview: {
    event_type: `${eventBaseType}_CATEGORY_VIEW`,
    category_path,
  },
  clickPDPCategorySubview: {
    event_type: `${eventBaseType}_CATEGORYVIEW_PDP_CLICK`,
    event_id: 'pdp click',
    category_id: category_id_detail,
    category_path: category_path_detail,
    event_category,
  },
  welcomeBannerView: {
    event_type: `${eventBaseType}_WELCOMEBANNER_VIEW`,
    event_id: 'welcome banner',
    event_label: 'welcome banner',
    event_category,
    category_id,
    category_path,
  },
  welcomeBannerclick: {
    event_type: `${eventBaseType}_WELCOMEBANNER_CLOSEICON_CLICK`,
    event_id: 'welcome banner closed',
    event_label: 'welcome banner closed',
    category_id,
    category_path,
  },
  myclosetViewWithItems: {
    event_type: `${eventBaseType}__WITH_ITEMS`,
    event_id: 'my closet with items',
    event_label: 'my closet with items',
    category_id,
    category_path,
    page_id: 'MY CLOSET WITH ITEMS',
  },
  myclosetDetailCloseBtn: {
    event_category,
    event_id: 'closet detail close',
    event_label: 'closet detail popup close',
    category_id: 'FAVOURITES_MY CLOSET',
    category_path: 'favourites/my_closet',
  },
}

export const MYCLOSET_DETAIL_TRACKING_EVENTS = {
  myclosetDetailView: {
    category_id: category_id_detail,
    category_path: category_path_detail,
  },
  myclosetLinkClicks: {
    event_category,
    category_id: category_id_detail,
    category_path: category_path_detail,
  },
}
